import { use_slice_workspace } from '@/hooks/store/use_slices';
import { md } from '@/utils/utils_html';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { format_timestamp_YY_MM_DD_HH_mm_ss } from '@shared/utils/utils_time';
import { useMemo } from 'react';
import { WSWorkspaceChildEntityOpenButton } from '../buttons/WSWorkspaceChildEntityOpenButton';
import { WSWorkspaceChildEntityStopSharingButton } from '../buttons/WSWorkspaceChildEntityStopSharingButton';

interface Props {
  item: DTO__workspace_child_enity;
  url: string;
}

export function WSSharedTableRow({ item, url }: Props) {
  const { all_workspaces_users_map, workspace_current } = use_slice_workspace(['all_workspaces_users_map', 'workspace_current']);

  const user_name = useMemo(() => get_user_name(), [item]);

  /*
   * EFFECTS
   */

  function get_user_name() {
    let users_from_this_workspace = all_workspaces_users_map.get_or_assert(workspace_current._id, { context: 'workspace_users' });

    let users = Array.from(users_from_this_workspace.values());
    users.sort(DTO__workspace_user.sort_by_name);

    const user_in_workspace = users.find(user => user.user_id == item.user_id_shared_by);

    //could be null if user already deleted from workspace
    return user_in_workspace?.full_name || '';
  }

  /*
   * HTML
   */

  return (
    <div className={`${md('px-2 justify-between', 'gap-5 pr-5 justify-start')} w-full min-h-[50px] flex flex-row items-center `}>
      <span className={`${md('w-[45px] text-[9px]', 'min-w-[45px] ')}  flex items-center justify-center gap-4`}>
        <WSWorkspaceChildEntityOpenButton url={url} />
        <WSWorkspaceChildEntityStopSharingButton entity={item} />
      </span>
      <span className={`${md('w-[45px] text-[9px]', 'min-w-[200px] max-w-[200px] w-[200px]')} text-left truncate whitespace-nowrap`}>{item.name}</span>
      <span className={`${md('w-[45px] text-[9px]', 'min-w-[200px]')}  text-left`}>{format_timestamp_YY_MM_DD_HH_mm_ss(item.sharing_started_at)}</span>
      <span className={`${md('w-[45px] text-[9px]', 'min-w-[120px]')}  text-left`}>{user_name}</span>
    </div>
  );
}
